import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Text from 'suitTheme/Text'
import styles from './styles.scss'

const Link = (props) => {
  const {
    as, children, className, disabledUnderline, disabled, greyLink, href, onClick, target, textProps, 
  } = props

  const rel = target === '_blank' ? 'noopener noreferrer' : null

  return (
    <Text
      as={as || 'a'}
      color={disabled ? 'lightGrey' : 'blue'}
      href={href}
      onClick={!disabled ? onClick : null}
      rel={rel}
      target={target}
      className={classnames(
        className,
        disabled ? styles.disabled : styles.root,
        disabledUnderline ? styles.disabledUnderline : null,
        greyLink ? styles.grey : null,
      )}
      {...textProps}
    >
      {children}
    </Text>
  )
}

Link.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledUnderline: PropTypes.bool,
  greyLink: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  textProps: PropTypes.object,
}

export default Link
